
document.addEventListener("vue:load", () => {
  require("fslightbox")
})
